import { UseLocalStore } from '../store/UseLocalStore';

export const useLocal = UseLocalStore;
